import * as UI from '@brewlogix/blx-ui'
import Link from 'next/link'
import React from 'react'
import LegacyFavoritesButton from 'src/features/favorites/components/LegacyFavoritesButton'
import { FavoriteType } from 'src/features/favorites/types/enums/FavoriteType'
import { useBrewDetailStore } from '../../state/useBrewDetailStore'
import { parseStateLabel } from '../../util/helpers'
import { MainImage } from '../Highlights'
import Details from './Details'
import { HStack } from '@chakra-ui/react'

const InfoContainer: React.FC = () => {
    const { productData } = useBrewDetailStore()
    const productTitle = productData?.title || null
    const brandTitle = productData?.brand?.displayTitle || productData?.brand?.title || null
    const brandState = parseStateLabel(productData?.brand?.address?.state) || ''
    const brandCity = parseStateLabel(productData?.brand?.address?.city) || ''
    const locationLabel = `${brandCity}${brandCity && brandState ? ',' : ''} ${brandState}`

    return (
        <div className='flex flex-col rounded-lg p-6 pr-4 md:p-10'>
            <div className='flex gap-5'>
                <div className='relative block h-28 w-28 rounded-lg bg-gray-50 lg:hidden'>
                    <MainImage />
                </div>
                <div className='w-full justify-between gap-4 lg:flex'>
                    <div className='flex-col gap-2 lg:flex'>
                        {productTitle && (
                            <HStack>
                                <div className='text-2xl font-extrabold text-dark'>
                                    {productTitle}
                                </div>
                                {productData?.isNewProduct === true && (
                                    <UI.Pill
                                        size='sm'
                                        customClasses='bg-green-200 text-green-600 font-bold rounded-md p-1'
                                        label='NEW'
                                    />
                                )}
                            </HStack>
                        )}
                        <div className='mt-2 gap-4 space-y-2 md:m-0 md:flex md:space-y-0'>
                            {brandTitle && (
                                <div className='flex flex-col items-start gap-4 sm:flex-row sm:items-center'>
                                    {productData?.brand?.slug ? (
                                        <Link
                                            href={{
                                                pathname: `/brewer/[brandSlug]`,
                                                query: {
                                                    brandSlug: productData?.brand?.slug,
                                                },
                                            }}
                                        >
                                            <a>
                                                <div className='font-lato cursor-pointer text-lg font-bold text-blue-300'>
                                                    {brandTitle}
                                                </div>
                                            </a>
                                        </Link>
                                    ) : (
                                        <div className='font-lato text-lg font-bold text-blue-300'>
                                            {brandTitle}
                                        </div>
                                    )}
                                </div>
                            )}
                            {locationLabel && (
                                <UI.Pill
                                    size='sm'
                                    customClasses='bg-blue-50 text-blue-500 fill-blue-500'
                                    icon='HeroIcons.LocationMarker'
                                    iconAlignment='left'
                                    label={locationLabel}
                                />
                            )}
                        </div>
                    </div>
                    <div className='-ml-1.5 mt-2 flex items-end lg:m-0'>
                        <LegacyFavoritesButton
                            hasText
                            type={FavoriteType.Product}
                            heartSize='md'
                            ariaLabel={`Add ${productData?.title} to your favorites`}
                            item={productData}
                        />
                    </div>
                </div>
            </div>
            <div>
                <Details />
            </div>
        </div>
    )
}

export default React.memo(InfoContainer)
